import axios from 'axios'

export const commonItemLike = {
  methods: {
    like(item_id) {
      axios.post(`/likes/items/${item_id}`)
      .then(() => {
        this.items[item_id] = true
      }).catch(error => {
        console.log(error)
      })
    },
    unlike(item_id, reload = false) {
      axios.delete(`/likes/items/${item_id}`)
      .then(() => {
        if(reload) location.reload()

        this.items[item_id] = false
      }).catch(error => {
        console.log(error)
      })
    }
  }
}